<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper" v-show="false">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称"/>
            </a-form-item>
          </a-col>

          <!--          <a-col :md="6" :sm="24">-->
          <!--            <a-form-item label="状态">-->
          <!--              <a-select v-model="queryParam.status" placeholder="请选择"-->
          <!--                        allowClear>-->
          <!--                <a-select-option value="1">使用中</a-select-option>-->
          <!--                <a-select-option value="2">未开始</a-select-option>-->
          <!--                <a-select-option value="3">已结束</a-select-option>-->
          <!--                &lt;!&ndash;                                <a-select-option value="2">已下架</a-select-option>&ndash;&gt;-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
    </div>

    <a-table
        ref="table"
        size="default"
        :columns="columns"
        :pagination="false"
        :dataSource="dataList"
    >
      <span slot="title1" slot-scope="text,record">
        <div>{{ record.name }}</div>
      </span>

      <span slot="rank" slot-scope="text,record">
        <span>{{ record.cash_fee + '%' }}</span>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </a-table>


    <a-modal
        title="结算规则设置"
        :width="800"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="名称"
              hasFeedback
          >
            <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入名称' }]}
        ]"
                     placeholder="请输入名称"/>
          </a-form-item>
<!--          <a-form-item-->
<!--              :labelCol="labelCol"-->
<!--              :wrapperCol="wrapperCol"-->
<!--              label="最低结算价格"-->
<!--              hasFeedback-->
<!--          >-->
<!--            <a-input v-decorator="[-->
<!--          'price_start'-->
<!--        ]"-->
<!--                     placeholder="请输入最低结算价格"/>-->
<!--          </a-form-item>-->
<!--          <a-form-item-->
<!--              :labelCol="labelCol"-->
<!--              :wrapperCol="wrapperCol"-->
<!--              label="合伙人结算费用"-->
<!--              hasFeedback-->
<!--              extra="支付结算价的百分之几"-->
<!--          >-->
<!--            <a-input v-decorator="[-->
<!--          'cash_fee'-->
<!--        ]"-->
<!--                     placeholder="合伙人结算费用"/>-->
<!--          </a-form-item>-->
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        title="小程序推广"
        v-model="shareVisible"
        @ok="shareVisible=false"
    >
      <p style="text-align: center"><img :src="share.wxmini_pic_url"/></p>
    </a-modal>
    <a-modal title="H5推广" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url"/>
      </p>
      <p>{{ share.site_url }} </p><a
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">点此复制</a>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PriceInput from '@/components/PriceInput/'
import PicUploader from '@/components/PicUploader/'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

import {
  getPartnerGroupList,
  addPartnerGroup,
  editPartnerGroup,
  getPartnerGroupDetail,
  deletePartnerGroup
} from '@/api/partnerGroup'
import {getSellerGroupList} from "@/api/businessSellerGroup";

export default {
  name: 'PartnerGroupList',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    PriceInput,
    PicUploader
  },
  data() {
    return {
      visible: false,
      userVisible: false,
      shareVisible: false,
      h5ShareVisible: false,
      share: {
        wxmini_pic_url: '',
        site_url: ''
      },
      areaVisible: false,
      saveLoading: false,
      formData: {
        id: 0,
        name: '',
        price_start: '',
        cash_fee: '',
      },
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      cateOptions: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: {customRender: 'title1'},
        },

        // {
        //   title: '最低结算价格',
        //   width: '200px',
        //   dataIndex: 'price_start',
        // },
        // {
        //   title: '结算比例',
        //   width: '100px',
        //   dataIndex: 'rank',
        //   scopedSlots: {customRender: 'rank'},
        // },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: {customRender: 'action'},
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        // this.queryParam.cate_id = 0;
        // if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
        //   this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
        // }
        this.queryParam = Object.assign(this.queryParam, parameter);
        return getPartnerGroupList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },
      selectedRowKeys: [],
      selectedRows: [],
      goodsOptions: [],
      sku_fields_list: [],
      setAll: {
        setAllPriceValue: ''
      },
      skuTable: {
        sku_fields_sets: [],
        sku_list: [],
      },

      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '团长',
          dataIndex: 'user_name',
          width: '150px',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'name',
          }
        },
        {
          title: '参与/成团人数',
          width: '100px',
          dataIndex: 'member_count',
          scopedSlots: {
            customRender: 'member_count',
          },
        },
        {
          title: '状态',
          width: '100px',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          filters: [
            {
              text: '使用中',
              value: '1'
            },
            {
              text: '完成',
              value: '2'
            },
            {
              text: '过期失败',
              value: '3'
            },
            {
              text: '未支付',
              value: '4'
            }],
          filterMultiple: false,
        },
        {
          title: '时间',
          width: '150px',
          dataIndex: 'time_start',
          scopedSlots: {
            customRender: 'time_start',
          },
        },
      ],
      userPagination: {
        pageSize: 30,
        page: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      userQuery: {
        tuan_id: 0,
        status: 0,
        page: 1,
        keywords: undefined
      },
      tuanUserList: [],
      dataList: [],
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    let that = this;
    that.fetch()
  },
  methods: {
    moment,
    handleChange(value) {
      console.log(value)
      let self = this;
      // getGoodsOptions({keywords: value}).then(res => {
      //     self.goodsOptions = res.data;
      // }).catch(err => {
      //     self.$message.error(err.data.msg)
      // })
    },
    fetch() {
      let self = this;
      getPartnerGroupList(this.queryParam)
          .then(res => {
            self.dataList = res.data;
          })
    },
    handleCancel() {
      this.visible = false
    },
    // 增
    handleAdd() {
      console.log('moment.locale()')
      console.log(moment.locale());

      let that = this;
      // that.getGoodsOptions();
      this.visible = true;
      this.form.resetFields();
      this.formData = {
        id: 0,
        name: '',
        price_start: '',
        cash_fee: '',
      };
      setTimeout(() => {
        that.form.setFieldsValue({...this.formData});
      });
    },
    // 改
    handleEdit(record) {
      let self = this
      getPartnerGroupDetail({id: record.id}).then(res => {
        self.form.setFieldsValue({...res.data})
        self.formData.id = record.id;
        self.formData = res.data
      })
      // console.log(this.mdl)
      this.visible = true
    },

    // 增改 处理
    handleOk(e) {
      let self = this
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true

          let data = {
            id: self.formData.id,
            name: values.name,
            price_start: values.price_start,
            cash_fee: values.cash_fee,
          }
          if (self.formData.id) {
            editPartnerGroup(data).then(res => {
              self.$message.success('修改成功')
              // self.$refs.table.refresh(true)
              self.fetch()
              self.visible = false
              self.saveLoading = false

            }).catch(err => {
              self.$message.error(err.data.msg)
              self.saveLoading = false
            })

          } else {
            addPartnerGroup(data).then(res => {
              self.$message.success('新增成功')
              // self.$refs.table.refresh(true)
              self.fetch()
              self.visible = false
              self.saveLoading = false
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        }
      })
    },

    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(true)
    },
    onCopy(e) {
      this.$message.success('复制成功')
    },
    onError(e) {
      this.$message.error('复制失败')
    },

    // 删
    deleteHandle(record) {
      let self = this
      deletePartnerGroup({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.fetch()
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
  watch: {
    /*
    'selectedRows': function (selectedRows) {
      this.needTotalList = this.needTotalList.map(item => {
        return {
          ...item,
          total: selectedRows.reduce( (sum, val) => {
            return sum + val[item.dataIndex]
          }, 0)
        }
      })
    }
    */
  }
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
